import { createFileRoute } from '@tanstack/react-router';
import { AdminSystemLogsPage } from '@/features/admin/admin-system-logs-page';

export const Route = createFileRoute('/admin/system-logs/')({
  component: AdminSystemLogsIndexRoute,
});

function AdminSystemLogsIndexRoute() {
  return <AdminSystemLogsPage />;
}
